import 'react-perfect-scrollbar/dist/css/styles.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'assets/sass/main.scss'

import React from 'react'
import Panel from 'components/panel'
import { render } from 'react-dom'
import { Route, Router, Redirect, Switch } from 'react-router'
import { Login } from 'components/login'
import { PrivateRoute } from 'core/components/route'
import { history } from 'core/helpers/history'
import { App } from 'App'
import { config } from 'config'
import { API } from 'service'
import { ParkingForm } from 'components/parking'
import { ParkingPixForm } from 'components/parking-pix'
import { CrediPurchaseForm } from 'components/credit-purchase'
import { StatementForm } from 'components/statement'
import { GratuityForm } from 'components/gratuity'
import { CustomerUpdateForm } from 'components/customer-update'
import { RegisterForm } from 'components/register'
import { PointOfSaleList } from 'components/point-of-sale'
import { PointOfSaleMap } from 'components/point-of-sale-map'
import { ParkingLotsList } from 'components/parking-lots'
import { ParkingLotsMap } from 'components/parking-lots-map'
import { Dashboard } from 'components/dashboard'
import { BuyStatementForm } from 'components/buy-statement'

const rootElement = document.getElementById('root')

render(
  <Router history={history}>
    <App>
      {global =>
        global.loading ? null : (
          <Switch>
            <Route
              exact
              path="/:city?/login/:token?"
              render={route => <Login global={global} route={route} />}
            />

            <Route
              exact
              path="/:city/cadastro"
              render={route => <RegisterForm global={global} route={route} />}
            />

            <Route
              exact
              path="/:city/estacionar-pix"
              render={route => <ParkingPixForm global={global} route={route} />}
            />

            <Route
              exact
              path="/:city/estacionar-pix/:plate"
              render={route => <ParkingPixForm global={global} route={route} />}
            />

            <Route
              exact
              path="/:city/mapa-pontos-venda"
              render={route => <PointOfSaleMap global={global} route={route} />}
            />

            <PrivateRoute
              path="/:city"
              render={route => (
                <Panel
                  base="/:city"
                  extraBasePaths={['/:city/veiculo/cadastro', '/:city/veiculo/:plate']}
                  global={global}
                  home={Dashboard}
                  pages={[
                    {
                      title: 'Meus Dados',
                      href: '/meus-dados',
                      icon: 'fas fa-user',
                      component: CustomerUpdateForm,
                      hideWhen: operator =>
                        !['Customer'].some(p => operator.user.permissions.includes(p)),
                    },
                    {
                      title: 'Extrato',
                      href: '/extrato',
                      icon: 'fas fa-copy',
                      component: StatementForm,
                      hideWhen: operator =>
                        !['Customer'].some(p => operator.user.permissions.includes(p)),
                    },
                    {
                      title: 'Ativar Cartão Digital',
                      href: '/ativar-cartao-digital',
                      icon: 'fas fa-clock',
                      component: ParkingForm,
                    },
                    {
                      title: 'Comprar Créditos',
                      href: '/comprar-creditos',
                      icon: 'fas fa-dollar-sign',
                      component: CrediPurchaseForm,
                      hideWhen: operator =>
                        !['Customer'].some(p => operator.user.permissions.includes(p)),
                    },
                    {
                      title: 'Recibos de Compra',
                      href: '/recibos-de-compra',
                      icon: 'fas fa-receipt',
                      component: BuyStatementForm,
                      hideWhen: operator =>
                        !['Customer'].some(p => operator.user.permissions.includes(p)),
                    },
                    {
                      title: 'Registrar Gratuidade',
                      href: '/gratuidade',
                      icon: 'fas fa-user-check',
                      component: GratuityForm,
                      hideWhen: operator =>
                        !operator.parameters.allowGratuity ||
                        !['Customer'].some(p => operator.user.permissions.includes(p)),
                    },
                    {
                      title: 'Mapa de Vagas',
                      href: '/vagas',
                      icon: 'fas fa-map',
                      component: ParkingLotsMap,
                    },
                    {
                      title: 'Pontos de Vendas',
                      href: '/pontos-venda',
                      icon: 'fas fa-store',
                      component: PointOfSaleList,
                    },
                    {
                      title: 'Vagas',
                      href: '/vagas',
                      icon: 'fas fa-map-marker-alt',
                      component: ParkingLotsList,
                      hideWhen: operator => !operator.parameters.parkingLotRequiredParking,
                    },
                  ]}
                  route={route}
                  service={API}
                  tokenKey={config.TOKEN_KEY}
                />
              )}
            />

            <Route render={() => <Redirect to="login" />} />
          </Switch>
        )
      }
    </App>
  </Router>,
  rootElement,
)
